
export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';

export const COMMIT = 'COMMIT';

export const FETCH_USER = 'FETCH_USER';